import React from 'react';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

export interface StepHeaderProps {
  number: number;
  title: string;
  helper?: string;
}

/** The numbered title of one step in a guided editor form. */
export const StepHeader: React.FC<StepHeaderProps> = ({ number, title, helper }) => (
  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mb: 1.5 }}>
    <Typography
      variant="caption"
      sx={{
        fontWeight: 700,
        color: 'primary.main',
        bgcolor: 'primary.50',
        borderRadius: '50%',
        width: 20,
        height: 20,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontSize: 11,
      }}
    >
      {number}
    </Typography>
    <Box>
      <Typography variant="body2" fontWeight={600}>{title}</Typography>
      {helper && (
        <Typography variant="caption" color="text.secondary">{helper}</Typography>
      )}
    </Box>
  </Box>
);

/** The bordered body under a StepHeader. */
export const StepBox: React.FC<{ children: React.ReactNode; sx?: SxProps<Theme> }> = ({ children, sx }) => (
  <Box sx={[{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2 }, ...(Array.isArray(sx) ? sx : [sx])]}>
    {children}
  </Box>
);
